var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpiritsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "spirits-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eazle---App-views",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-products",
    transform: "translate(-48, -559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-3",
    transform: "translate(24, 535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spirits-icon",
    transform: "translate(24, 24)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "spirits",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-4)",
    fill: "#00414B"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.3333, 2.3333)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.258542611,0.329 C0.448129277,0.119506667 0.717475944,0 1,0 L26.3333293,0 C26.6158626,0 26.8851959,0.119506667 27.0747959,0.329 C27.2643959,0.53848 27.3565293,0.818373333 27.3283959,1.09950667 L24.7950626,26.4328 C24.7438626,26.944 24.3137293,27.3333333 23.7999959,27.3333333 L3.53332928,27.3333333 C3.01958261,27.3333333 2.58942261,26.944 2.53830261,26.4328 L0.00496927741,1.09950667 C-0.0231507226,0.818373333 0.0689692774,0.53848 0.258542611,0.329 Z M2.10498261,2 L3.84764928,19.4266667 L23.4857293,19.4266667 L25.2283959,2 L2.10498261,2 Z M23.2857293,21.4266667 L4.04764928,21.4266667 L4.43831594,25.3333333 L22.8950626,25.3333333 L23.2857293,21.4266667 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6243693,3.71337333 C11.1439959,3.52614667 11.7169293,3.79558667 11.9041293,4.31516 L13.8749293,9.78434667 C13.9647959,10.0338667 13.9518626,10.3088667 13.8390626,10.54888 C13.7261293,10.78888 13.5225293,10.9742267 13.2730626,11.0641333 L7.80388928,13.0348 C7.55438261,13.1248 7.27936928,13.1118667 7.03936928,12.9990667 C6.79935594,12.8861333 6.61400928,12.6825333 6.52410261,12.4330667 L4.55338261,6.96388 C4.36616928,6.44429333 4.63559594,5.87132 5.15518261,5.68409333 L10.6243693,3.71337333 Z M6.77395594,7.22666667 L8.06668928,10.81428 L11.6542626,9.52154667 L10.3615693,5.93394667 L6.77395594,7.22666667 Z M15.1861293,9.78042667 C15.3413293,9.25037333 15.8967959,8.94645333 16.4267959,9.1016 L22.0058626,10.73456 C22.5358626,10.8897067 22.8398626,11.4452 22.6846626,11.9752 L21.0517293,17.5542667 C20.9771959,17.8088 20.8046626,18.0233333 20.5719959,18.1506667 C20.3393293,18.2778667 20.0655959,18.3076 19.8110626,18.2330667 L14.2319959,16.6001333 C13.7019959,16.4449333 13.3979959,15.8894667 13.5531959,15.3594667 L15.1861293,9.78042667 Z M16.8246626,11.302 L15.7535959,14.9616 L19.4131959,16.0326667 L20.4842626,12.3730667 L16.8246626,11.302 Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiritsIcon);
export default __webpack_public_path__ + "static/media/spirits-icon.8ff77fd41cbe76a7153507589b2b5b26.svg";
export { ForwardRef as ReactComponent };